import styled from 'styled-components'
import { themeGet } from 'styled-system'
import ReactMarkdown from 'react-markdown'

export const Wrapper = styled.div.attrs(props => ({
  isCreateClass: props.isCreateClass,
}))`
  height: 293px;
  border-radius: 10px;
  background-color: ${props =>
    props.isCreateClass
      ? themeGet('primaryCTA.create.backgroundColor')
      : themeGet('primaryCTA.training.backgroundColor')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 1.75rem;
`

export const IconWrapper = styled.div`
  width: 75px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const TitleWrapper = styled.div.attrs(props => ({
  isCreateClass: props.isCreateClass,
}))`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${props =>
    props.isCreateClass
      ? themeGet('primaryCTA.create.titleColor')
      : themeGet('primaryCTA.training.titleColor')};
  font-weight: 600;
  font-size: 23px;
  line-height: 24px;
  letter-spacing: 0.41px;
  margin-top: 1rem;
`

export const DescriptionWrapper = styled(ReactMarkdown)`
  font-family: ${themeGet('font.molde.regular')};
  color: #555555;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0px;
  margin-top: 1rem;
`

export const ButtonWrapper = styled.button.attrs(props => ({
  isCreateClass: props.isCreateClass,
}))`
  width: 154px;
  height: 43px;
  border-radius: 5px;
  background-color: ${props =>
    props.isCreateClass
      ? themeGet('primaryCTA.create.buttonColor')
      : themeGet('primaryCTA.training.buttonColor')};
  margin-top: 1rem;
  border: none;
  outline: none;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-weight: 600;

  &:hover {
    background-color: ${props =>
      props.isCreateClass
        ? themeGet('primaryCTA.create.buttonHoverColor')
        : themeGet('primaryCTA.training.buttonHoverColor')};
  }

  &:focus {
    outline: 2px solid #3c6e90;
    outline-offset: 2px;
  }
`
